<template>
  <div>
    <el-form ref="form_data" :model="form_data" labelWidth="100px" labelPosition="left"
             style="margin-top: 20px; overflow: auto;">
      <el-row style="min-width: 540px;">
        <el-col :xs="12" :sm="13" :md="8" :lg="5" :xl="5">
          <el-form-item label="版本号">
            <el-col :span="11">
              <el-select filterable v-model="form_data.version" placeholder="选择版本" @change="submitForm('ios')" clearable
                         style="width: 150px">
                <el-option v-for="item in select_data.version" :label="item.key" :key="item.key"
                           :value="item.key"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="13" :md="8" :lg="5" :xl="5">
          <el-form-item label="Build号">
            <el-col :span="11">
              <el-input v-model="form_data.buildNum" placeholder="输入build号" clearable style="width: 150px"
                      @change="submitForm('ios')"></el-input>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="13" :md="8" :lg="5" :xl="5">
          <el-form-item label="环境">
            <el-col :span="11">
              <el-select v-model="form_data.env" placeholder="选择打包环境" clearable style="width: 150px"
                         @change="submitForm('ios')">
                <el-option v-for="item in select_data.env" :label="item.key" :key="item.key"
                           :value="item.key"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="13" :md="8" :lg="5" :xl="5">
          <el-form-item label="打包机器名字">
            <el-col :span="11">
              <el-select v-model="form_data.sourceMac" placeholder="选择打包机器名字" clearable style="width: 150px"
                         @change="submitForm('ios')">
                <el-option v-for="item in select_data.machine" :label="item.key" :key="item.key"
                           :value="item.key"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="min-width: 540px;">
        <el-col :xs="12" :sm="13" :md="8" :lg="5" :xl="5">
          <el-form-item label="打包分支">
            <el-col :span="11">
              <el-select filterable v-model="form_data.branch" placeholder="选择打包分支" clearable style="width: 150px"
                         @change="submitForm('ios')">
                <el-option v-for="item in select_data.branch" :label="item.key" :key="item.key"
                           :value="item.key"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="13" :md="8" :lg="5" :xl="5">
          <el-form-item label="上传时间">
            <el-col :span="11">
              <el-date-picker type="date" placeholder="选择上传时间" v-model="form_data.uploadTime"
                              clearable style="width: 150px; " @change="submitForm('ios')"
                              value-format="timestamp"></el-date-picker>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="13" :md="8" :lg="5" :xl="5">
          <el-form-item label="APK-MD5">
            <el-col :span="11">
              <el-input v-model="form_data.md5" clearable style="width: 150px"
                      @change="submitForm('ios')" placeholder="输入apk-md5值"></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table :header-cell-style="{background:'#E4E7ED'}" :data="list"
                    style="width: 100%;margin-top: 30px" :highlightCurrentRow="true" @row-click="handleClick"
                    v-loading="loading">
      <el-table-column prop="name" label="应用名称" style="width: 20%" align="center"></el-table-column>
      <el-table-column prop="version" label="版本 - Build号" style="width: 20%" align="center"></el-table-column>
      <el-table-column prop="source" label="来源" style="width: 20%" align="center"></el-table-column>
      <el-table-column prop="app_url" label="下载" style="width: 20%" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button icon="el-icon-download" circle></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="branch" label="分支" style="width: 20%" align="center"></el-table-column>
      <el-table-column prop="env" label="操作" style="width: 20%" align="center"></el-table-column>
      <el-table-column prop="md5" label="MD5" style="width: 20%" align="center"></el-table-column>
      <el-table-column prop="upload_time" label="更新时间" style="width: 20%" align="center"></el-table-column>
    </el-table>
      <el-pagination
        background
        @size-change="handleSizeChangeIos"
        @current-change="handleCurrentChangeIos"
        :current-page="Number(page)"
        :page-sizes="[10,15,20]"
        :page-size="10"
        layout="total, sizes, prev, next, pager, jumper"
        :total="total_count"
        style="margin-top: 30px; overflow-x: auto;">
      </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    select_data: {
      type: Object
    },
    appid: {
      type: String
    },
    list: {
      type: Array
    },
    total_count: {},
    page_size: {
      default: 10
    },
    page: {
      default: 1
    }
  },
  data () {
    return {
      loading: false,
      currentPageIos: 1,
      currentPageSizeIos: 10,
      form_data: {

      }
    }
  },
  methods: {
    handleCurrentChangeIos (val) {
      this.$emit('search', {
        form: this.form_data,
        size: this.page_size,
        page: val,
        appid: this.appid
      })
      this.$store.commit('iosPageSize', this.page_size)
    },
    handleSizeChangeIos (val) {
        this.$emit('search', {
          form: this.form_data,
          size: val,
          page: this.page,
          appid: this.appid
        })
        this.$store.commit('iosPage', this.currentPageIos)
      },
    submitForm () {
      if (!this.form_data.uploadTime) {
        this.form_data.uploadTime = ''
      }
      this.$emit('search', {
        form: this.form_data,
        size: this.page_size,
        // page: this.page,
        appid: this.appid
      })
    },
    handleClick (row) {
      this.$router.push({
        path: '/info',
        query: {
          app_id: row.app_id,
          version: row.version,
          build_num: row.build_num,
          package_id: row.package_id
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tabcontent.vue